
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { PRICE_UPDATE_STATUS } from '../../core/router/paths';

export default (scrapeTime: Date) =>
{
  return ([
    "Last updated " + new Date(scrapeTime).toLocaleDateString(
      'en-GB',
      { year: 'numeric', month: 'numeric', day: 'numeric' }),
    <br key={"price-update-status-linebreak"}/>,
    <Link
      key={"price-update-status-link"}
      variant='body2'
      fontSize={12}
      to={PRICE_UPDATE_STATUS}
      component={RouterLink}
      target='_blank'
      color='#FFFFFF'>
      Price update status
    </Link>])
}